export default "__VITE_ASSET__bc8b68f4__"